import { View, Text } from 'react-native';
import React, { useContext } from 'react';
import { Divider } from 'react-native-paper';
import { StyleSheet } from 'react-native';
import { I18nNamespace } from '@zonofi/i18n';
import { InfoTooltip } from '../info-tooltip/info-tooltip';
import { ThemeContext } from '../contexts/ThemeContext';

export interface DetailsSectionProps {
  heading: string | JSX.Element;
  divider?: boolean;
  value?: JSX.Element | JSX.Element[];
  style?: object;
  tooltip?: {
    path: string[];
    dataKey: string;
    namespace: I18nNamespace;
  };
}

export const DetailsSection: React.FC<DetailsSectionProps> = ({
  heading,
  divider,
  value,
  style,
  tooltip,
}) => {
  const currentTheme = useContext(ThemeContext);
  const { theme } = currentTheme;
  return (
    <View
      style={[
        {
          margin: 0,
          marginBottom: 8,
          marginTop: 0,
          backgroundColor: '#fff',
          borderRadius: 12,
          padding: 16,
          borderWidth: 1,
          borderColor: '#d9d9d9',
        },
        style,
      ]}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 2,
          paddingBottom: 8,
        }}
      >
        {typeof heading === 'string' ? (
          <Text
            style={[
              styles.heading,
              {
                fontFamily: theme.fontConfig.semiBold.fontFamily,
                color: '#000',
              },
            ]}
          >
            {heading}
          </Text>
        ) : (
          heading
        )}
        {tooltip && (
          <InfoTooltip
            namespace={tooltip.namespace}
            path={tooltip.path}
            title={tooltip.dataKey}
          />
        )}
      </View>
      {value}
      {/* {divider && (
        <Divider
          style={{
            // backgroundColor: theme.highlight.divider.primary,
            backgroundColor: '#DFE0E0',
            height: 1,
            marginVertical: 16,
          }}
        />
      )} */}
    </View>
  );
};

const styles = StyleSheet.create({
  heading: {
    fontSize: 14,
    paddingLeft: 0,
  },
});

export default DetailsSection;
